import { BehaviorSubject } from 'rxjs';

const obj = new BehaviorSubject(JSON.parse(localStorage.getItem("authUser")))

export const auth = {
  authUser: obj,
  get authHeader () { return 'Bearer ' + obj?.value?.token || ''},
  get currentUserValue() { return obj.value }
}